// Libraries
import React, { Component, createRef } from 'react';

// Components
import { translate } from '../../globals/translations';
import { validateValue } from '../../abstract/validation';

class Input extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valueType: props.valueType || '',
            inputValue: props.value || '',
            required: !!props.isRequired,
        };

        this.inputRef = createRef();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.value !== prevProps.value &&
            this.props.value !== undefined
        ) {
            this.setState({ inputValue: this.props.value }, this.clearError);
        }
    }

    handleChange = (e) => {
        const { valueType, required } = this.state;
        const { name, value } = e.target;
        const validated = validateValue(valueType, value);

        if (!valueType || validated) {
            this.setState({
                inputValue: name === 'email' ? value.trim() : value,
            });
        }

        if (required) {
            this.validateField(e.target, validated);
        }
    };

    validateField = (field, isValid) => {
        const errorMsg = document.querySelector(`[data-for="${field.name}"]`);
        const hasError = !field.value || (this.state.valueType && !isValid);

        field.classList.toggle('error', hasError);

        if (errorMsg) {
            errorMsg.classList.toggle('-hidden', !hasError);
        }
    };

    clearError = () => {
        const formInput = document.getElementById(this.props.inputName);

        if (formInput) {
            formInput.classList.remove('error');

            const errorMsg = formInput.nextElementSibling;

            if (errorMsg) {
                errorMsg.classList.add('-hidden');
            }
        }
    };

    handleClick = (e) => {
        if (e.target.value) {
            e.target.select();
        }
    };

    handleKeyDown = (e) => {
        if (this.props.suppressChar && e.key === this.props.suppressChar) {
            e.preventDefault();
        }
    };

    render() {
        const { inputValue, required } = this.state;
        const {
            inputName,
            inputClass = '',
            containerClass = '',
            inputPlaceholder,
            labelText,
            labelHelperText = '',
            inputType = 'text',
            helperText = '',
            validationMsg,
            autoComplete = 'off',
            id = inputName,
            inputDisabled,
            readOnly,
            onFocus,
            onBlur,
            onChange,
            forwardedRef,
            ariaHidden,
        } = this.props;

        const input = {
            name: inputName,
            containerClass: `${containerClass} form-group-container`.trim(),
            placeholder: inputPlaceholder || inputName,
            label: labelText || inputName,
            type: inputType,
            validationMsg: validationMsg || translate('please_valid_entry'),
            autocomplete: autoComplete,
            id,
        };

        return (
            <>
                {input.type === 'hidden' ? (
                    <input
                        type={input.type}
                        name={input.name}
                        className={input.containerClass}
                        value={inputValue}
                        onChange={this.handleChange}
                        autoComplete={input.autocomplete}
                    />
                ) : (
                    <div className={input.containerClass}>
                        <div
                            className="form-group"
                            data-translation-key={inputName.toLowerCase()}
                        >
                            <label htmlFor={input.name}>{input.label}</label>
                            {labelHelperText && (
                                <span className="form-helper-text">
                                    {labelHelperText}
                                </span>
                            )}
                            <input
                                type={input.type}
                                id={input.id}
                                name={input.name}
                                placeholder={input.placeholder}
                                className={`form-control${
                                    required ? ' required' : ''
                                } ${inputClass}`.trim()}
                                value={inputValue}
                                onChange={onChange || this.handleChange}
                                onClick={this.handleClick}
                                disabled={inputDisabled}
                                autoComplete={input.autocomplete}
                                onKeyDown={this.handleKeyDown}
                                readOnly={readOnly}
                                onFocus={onFocus}
                                onBlur={onBlur}
                                ref={forwardedRef}
                                aria-required={required}
                                aria-hidden={ariaHidden}
                                aria-describedby={
                                    helperText
                                        ? `${input.id}-helper`
                                        : labelHelperText
                                        ? `${input.id}-label-helper`
                                        : undefined
                                }
                            />
                            {helperText && (
                                <span
                                    id={`${input.id}-helper`}
                                    className="form-helper-text"
                                >
                                    {helperText}
                                </span>
                            )}
                            <span
                                className="form-error-msg -hidden"
                                data-for={input.name}
                            >
                                {input.validationMsg}
                            </span>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

const forwardRef = (props, ref) => <Input {...props} forwardedRef={ref} />;

export default React.forwardRef(forwardRef);
